import photoIcon from "../../assets/images/ico_photo.png";
import ngIcon from "../../assets/images/ico_ng.png";
import okIcon from "../../assets/images/ico_ok.png";
import naIcon from "../../assets/images/ico_na.png";
import requiredIcon from "../../assets/images/ico_required.png";
import { useTranslation } from "react-i18next";
import { getLanguageText } from "../../services/GlobalUtil";

const makeVisualMap = (list) => {
  const groupedMap = list
    .sort((a, b) => a.testItemIdx - b.testItemIdx)
    .reduce((map, visualData) => {
      const category = visualData.category;

      if (!map[category]) {
        map[category] = [];
      }

      map[category].push(visualData);
      return map;
    }, {});

  return groupedMap;
};

const getValue = (type, value) => {
  if (type === "ThreeLevelCheck") {
    if (value === "G") {
      return <img src={okIcon} alt="Good" />;
    } else if (value === "A") {
      return <img src={requiredIcon} alt="Attention" />;
    } else if (value === "R") {
      return <img src={ngIcon} alt="Repair" />;
    } else if (value === "X") {
      return <img src={naIcon} alt="Not Applicable" />;
    }
  } else {
    return value;
  }
};

const RowVisualInsp = ({ data }) => {
  return (
    <>
      {data.map((info, index) => (
        <tr key={index}>
          <td>{info.testItemIdx}</td>
          <td>{getValue(info.type, info.value)}</td>
          {index === 0 ? (
            <td rowSpan={data.length}>{getLanguageText(info.category)}</td>
          ) : null}
          <td style={{ textAlign: "left" }}>
            {getLanguageText(info.subCategory)}
          </td>
          <td>{info.commentText}</td>
          <td>{info.commentDraw ? <img src={photoIcon} alt="photo" /> : ""}</td>
        </tr>
      ))}
    </>
  );
};

const TableVisualInsp = ({ list }) => {
  const data = makeVisualMap(list);
  const { t } = useTranslation();

  return (
    <table style={{ tableLayout: "fixed" }}>
      <colgroup>
        <col style={{ width: "8%" }} />
        <col style={{ width: "12%" }} />
        <col style={{ width: "12%" }} />
        <col style={{ width: "auto" }} />
        <col style={{ width: "15%" }} />
        <col style={{ width: "12%" }} />
      </colgroup>
      <tbody>
        <tr>
          <th>{t("L0130")}</th>
          <th>{t("L0176")}</th>
          <th style={{ textAlign: "left" }} colSpan={2}>
            {t("L0127")}
          </th>
          <th>{t("L0254")}</th>
          <th>{t("L0255")}</th>
        </tr>
        {data.generalHood?.length > 0 && (
          <RowVisualInsp data={data.generalHood} />
        )}
        {data.tires?.length > 0 && <RowVisualInsp data={data.tires} />}
        {data.battery?.length > 0 && <RowVisualInsp data={data.battery} />}
        {data.interior?.length > 0 && <RowVisualInsp data={data.interior} />}
        {data.inventory?.length > 0 && <RowVisualInsp data={data.inventory} />}
        {data.body?.length > 0 && <></>}
      </tbody>
    </table>
  );
};

export default TableVisualInsp;
